import { Component, OnInit, Inject } from '@angular/core';
import { constants } from "src/app/shared/common/contants";
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { validationmethod } from "src/app/shared/common/validationmethod";
import { Actionbutton } from "src/app/shared/common/Actionbutton";
import { ReportTemplateButton } from "src/app/shared/common/ReportTemplateButton";
import { TrnxCommonTs } from "src/app/shared/common/trnxCommonTs";
import { ActivatedRoute } from "@angular/router";
import { TrnxBasePopupScreenComponent } from "src/app/user/trnx-base-popup-screen/trnx-base-popup-screen.component";
import { Router } from '@angular/router';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { TrnxchildBaseScreenComponent } from '../trnxchild-base-screen/trnxchild-base-screen.component';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { ReportTemplatePopupComponent } from "src/app/user/report-template-popup/report-template-popup.component";
import {VaultObjectRefereshButton} from "../../shared/common/vault-object-referesh-button.component";
import {DynamicscreendFileDownload} from '../../shared/common/dynamicscreend-fileownload-link.component';
import {FiledownloadComponent} from '../../shared/common/filedownload.component';
import { ObjectMetadataRefreshHistoryPopupComponent } from '../objectMetadataRefresh-history-popup/objectMetadataRefresh-history-popup.component';
import { log } from 'console';
import { BuildButton } from 'src/app/shared/common/BuildButton';
import { DownloadLogFile } from 'src/app/shared/common/DownloadLogFileButton';
import { CheckoutFiles } from 'src/app/shared/common/CheckoutFiles';
import { DetectChangesPopupVaultObjectComponent } from '../detect-changes-popup-vault-object/detect-changes-popup-vault-object.component';
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';
import { AsignUserRoleService } from 'src/app/shared/services/asign-user-role.service';
import { ScreensService } from 'src/app/shared/services/screens.service';
import { ChangeDetectorRef } from '@angular/core';
import { CustomCheckBoxButton } from 'src/app/shared/common/checkBoxButton';
import { CustomCheckButton } from 'src/app/shared/common/Checkbutton';
import { VaultObjectRelationshipService } from 'src/app/shared/services/vault-object-relationship.service';
import { UploadExcelFileComponent } from '../upload-excel-file/upload-excel-file.component';
import { ImportJsonComponent } from 'src/app/shared/common/ImportJsonComponent ';
import { ExecuteMDLScript } from 'src/app/shared/common/ExecuteMDLScript';
import { ImportZipComponent } from 'src/app/shared/common/ImportZipDialogData ';
import { CommonPopupSearchComponent } from '../common-popup-search/common-popup-search.component';
import { ImportExportCentralizedComponent } from '../import-export-centralized/import-export-centralized.component';


@Component({
    selector: 'app-trnx-base-screen',
    templateUrl: './trnx-base-screen.component.html',
    styleUrls: ['./trnx-base-screen.component.scss'],
    standalone: false
})
export class TrnxBaseScreenComponent implements OnInit {

  fixedTotalPageRecord;

  gridAPI;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  gridColumnAPI;

  columnDefs;
  columnDefsCategory;
  categoriesList;
  filteredData;

  rowClassRules;

  defaultColDef;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  pageSize;

  components: any;

  overlayNoRowsTemplate;

  listObjectDropDown: any = [];

  dynamicData = [];

  trnxScreenId;

  ngModelObject = [];

  ngModelObjectDivision = [];

  bootstrapColumn = 0;

  //dropDowns = [];

  retrieveObject: any = [];

  headerNameHtml = "";

  buttonName;

  tableName = "";

  tableID = "";

  agGridShow = false;

  retrieveNgModelCreation: any = [];

  screenType

  value;

  recordsStart = 0;

  screenTypeTOrM = "";

  backgroundColorScreen = "";

  backgroundColorButton = "";

  isdisable:boolean=false;

  buttonIdList: any = [];

  params;
  droupDownBindedIdName;
  droupDownBindedName;
  s3Path:any;
  logFilePath:any;
  temprunHistory;
  res;
  objects=[];
  dnsnames:any=[];
  name;
  selectedDns;
   defaultLoginDns:any;
  isEnabled = false;
  users
  vaultids:any=[];
  defaultId: number;
  importExportTableName = "loadobjectsmstr";

  rowData: any;
  userRoleNameData: any;
  columnsOfAction: boolean;
  navLinks = [
    {
      label: 'Objects',
      link: 'trnxBaseComponent?screenType=Dynamic%2FTransactions&tableName=objectmetadata&headerNameHtml=Objects',
      index: 0
    },
    {
      label: 'Stage Objects',
      link: 'stageobject',
      index: 1
    },
    {
      label: 'Objects Mapping',
      link: 'mappingconfiguration',
      index: 1
    },
    {
      label: 'Attributes Mapping',
      link: 'attributemappingconfig',
      index: 1
    },
    {
      label: 'Value Mapping',
      link: 'fieldMapping',
      index: 1
    },
     {
        label: 'Exception Queries',
        link: 'exceptionQueries',
        index: 1
      }
   
  ];

  uploadFile: boolean;
  tableNameForUploadFile: string;
  file: boolean;
  dataFiltered: any;
  uploadData: any;
  excelData: any;


  //constructor
  constructor(
    private router: Router,
    private constants: constants,
    private validation: validationmethod,
    private trnxCommonTs: TrnxCommonTs,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private service: CommonService,
    private spinner: NgxUiLoaderService,
    private snackbar: MatSnackBar,
    private localStorageSettings: LocalStorageSettingsService,
    private auth: LoginService,
    private userRoutingModule: UserRoutingModule,
    private reportLinkService:ReportlinksserviceService,
    private asignUserRoleService:AsignUserRoleService,
    private screenService: ScreensService,
    private cdRef: ChangeDetectorRef,

    private commonService:CommonService,

    private vaultObjectRelationshipService:VaultObjectRelationshipService

  ) {

    //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;
  }
 refresh= false;
  async ngOnInit() {
    
    console.log("+++++++++++++++++++++++++++++++++++++++++++")

    this.route.queryParams.subscribe(
      v => {
        console.log("+++++++++++++++++++++++++++++++++++++++++++")
        this.spinner.start();
        console.log(v);
        this.tableName = v.tableName;
        console.log(this.tableName)
        this.headerNameHtml = v.headerNameHtml;
        if(this.headerNameHtml==="Objects"){
         // this.headerNameHtml="Objects";
        this.refresh= true;
        }
        if(this.headerNameHtml == "Load Objects") {
          this.uploadFile = true;
          // this.tableNameForUploadFile = this.headerNameHtml
        }
        if(this.headerNameHtml == "Source Data Extraction Queries"){
          this.file= true
          // this.tableNameForUploadFile = this.headerNameHtml
        }
        this.screenType = v.screenType;
        console.log(this.screenType)
        this.spinner.stop();

      }
    )

    this.reportLinkService.screenoperationspermission(this.tableName,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }


       });
       
    });

  //     // Retrieve dnsName from localStorageSettings
  // const dnsName = this.localStorageSettings.getSettings("dnsName");
  // console.log("Selected DNS:", dnsName);

  // // Fetch data based on dnsName and tableName
  // this.service.getTableDataByDns(this.tableName, dnsName).subscribe(res => {
  //   console.log("Filtered Data:", res);
  //   this.dynamicData = res;
    
  //   // Load data to UI
  //   this.loadGridData();
  // });
       

    // if screens is one of vaultconfigmstr,users or company then only addrecord button should be enabled else disabled
    if (this.tableName == "vaultconfigmstr" || this.tableName == "users" || this.tableName == "company") {

      if(localStorage.getItem("dnsName")!=="1"){
        this.isdisable = true;
      }else{
        this.isdisable = false;
      }
    }


    // if screens is jsuiteproperties and loggedin user is from partnersi dns then a show dns drop down
    if (this.tableName == "jsuitepropertiesmstr") {

      if(localStorage.getItem("dnsName")!=="1"){
        this.isdisable = true;
      }else{
        this.isdisable = false;
      }
    }

    if (this.tableName == "templatecreationmstr") {

      //cell rendering in ag-grid
      this.components = {
        buttonRenderer: ReportTemplateButton,
      }

    }
   else if(this.tableName == "objectmetadata"){
   

     //added button for refresh attributes for vault object screen
      this.components = {
        buttonRenderer: VaultObjectRefereshButton,
        headerRenderer:CustomCheckButton
      }

    }
    else if(this.tableName == "keyphrasescatalogmstr"){
       this.components = {
         buttonRenderer: BuildButton,
         logfile:DownloadLogFile,
         dynamicscreendownloadLink:DynamicscreendFileDownload,
       }
      }
      /**
     * @Author-Asha W
     * @Date-12-12-2025
     * Added condition for Manage workspace to add execute mdl script button
     */
       else if(this.tableName == "tenantmanagementmstr"){
       this.components = {
         buttonRenderer: ExecuteMDLScript,
       }
      }

    else {

      //cell rendering in ag-grid
      this.components = {
        buttonRenderer: Actionbutton,
        /**
         * @author Ravi G
         * @Date 27-01-2023
         * @Desc filepath download button .ts for all dynamic screen
         */
        dynamicscreendownloadLink:DynamicscreendFileDownload,

      }

    }

    let retrieveNgModelCreation: any = [];

    retrieveNgModelCreation = await this.trnxCommonTs.ngModelTrnxObjectCreation(this.tableName);

    this.dynamicData = retrieveNgModelCreation[0];
    this.objects = retrieveNgModelCreation[0];

    console.log(this.dynamicData);

    this.trnxScreenId = retrieveNgModelCreation[6];
    console.log(this.trnxScreenId)

    this.ngModelObject = retrieveNgModelCreation[1];

    console.log(this.ngModelObject);

    this.ngModelObjectDivision = retrieveNgModelCreation[2];

    console.log(this.ngModelObjectDivision);

    this.bootstrapColumn = retrieveNgModelCreation[3];

    console.log(this.bootstrapColumn);

    this.tableID = retrieveNgModelCreation[4];

    console.log(this.tableID);

    this.screenTypeTOrM = retrieveNgModelCreation[7];

    console.log(this.screenTypeTOrM);

    this.agGridShow = await retrieveNgModelCreation[5];

    // array to bind data to ag grid this.validation.equalto("password")
    this.columnDefs = [];

    if (this.headerNameHtml == 'JSuite Properties') {
      
      this.columnDefsCategory = [
        {
          headerName: 'Property Categories',
          field: 'propertycategory1',
          sortable: true,
          filter: true,
          resizable: true,
          cellStyle: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#333'
          },
          headerComponentParams: {
            template:
              '<div style="font-weight: bold; font-size: 18px; color: #000;">Property Categories</div>'
          }
        }
      ];
      
     
    }

    if (this.tableName == "templatecreationmstr") {

      this.columnDefs.push({
        headerName: "Action",
        filter: false,
        cellRenderer: "buttonRenderer",
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this),
          schedule: this.scheduleIcon.bind(this)
        },
        pinned: 'left',
        lockPinned: true,
        width: 170
      });

    }

    else if (this.tableName == "objectmetadata") {
      const workspaceId = this.localStorageSettings.getSettings("WorkspaceId")
      this.commonService.retrieveDnsInfo(workspaceId).subscribe((response) => {
        console.log(response);
        
        if (response.error == true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, 'OK', { duration: 5000 });
          return null;
        } else {
          this.spinner.stop();
          const dnsInfoList = response;

  // Iterate and extract specific fields if needed
  dnsInfoList.forEach((item) => {
    console.log("Environment Name:", item.envname);
    console.log("DNS Name:", item.dnsname);
    console.log("Session ID:", item.sessionid);
    console.log("Tenant ID:", item.tenantid);
    // Access other fields as needed
  });

  // Or store it in a variable to use in HTML
    // const dnsDataArray = dnsInfoList;
    const dnsDataArray = response.map(item => ({
      id: item.vaultId,                         // backend vaultId → id
      name: item.envname,                       // envname → name
      source: item.dnsname,                     // dnsname → source (or sourceDnsId?)
      sourceDnsId: item.vaultconfigmstrid,     // vaultconfigmstrid → sourceDnsId
      target: item.dnsname,                     // dnsname again? Or from another field?
      targetDnsId: item.tenantid,               // tenantid → targetDnsId
      url: `https://${item.envname}/api`        // construct URL from envname or another field
    }));
    console.log(dnsDataArray)
    this.vaultids = dnsDataArray
    console.log(this.vaultids)
    this.dnsDropDown()
        }
      });
      // added button for refresh attribute
     
      this.columnDefs.push({
        headerName: "Action",
        field: "isSelected",
        filter: false,
        headerComponent:"headerRenderer",
        headerComponentParams: {
          updateCheckbox: this.onHeaderCheckboxChange.bind(this)
        },
        cellRenderer: "buttonRenderer",
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this),
          refreshAttribute: this.refreshAttribute.bind(this),
           pageLayoutDetails: this.pageLayoutDetails.bind(this) ,
          onCheckboxChange:this.checkboxIcon.bind(this)
        },
        pinned: 'left',
        lockPinned: true,
        width: 250
      });
     

    }
    else if (this.tableName == "keyphrasescatalogmstr") {
      console.log(this.columnDefs);
      this.columnDefs.push({
        headerName: "Action",
        filter: false,
        cellRenderer: "buttonRenderer",
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this),
          build:this.buildIcon.bind(this),

        },
        pinned: 'left',
        lockPinned: true,
        width: 170
      }
      );
    }
    /**
     * @Author-Asha W
     * @Date-12-12-2025
     * Added condition for Manage workspace to add execute mdl script button
     */
     else if (this.tableName == "tenantmanagementmstr") {
      console.log(this.columnDefs);
      this.columnDefs.push({
        headerName: "Action",
        filter: false,
        cellRenderer: "buttonRenderer",
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this),
          execute:this.executeMdlScript.bind(this),

        },
        pinned: 'left',
        lockPinned: true,
        width: 170
      }
      );
    }

    else {

      // This if condition is to remove Edit and Delete Icon from Login audit screen.
      if(this.tableName !== 'loginauditmstr' && this.tableName !== 'exceptionsmstr'){

      this.columnDefs.push({
        headerName: "Action",
        filter: false,
        cellRenderer: "buttonRenderer",
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.editIcon.bind(this),   
          delete: this.deleteIcon.bind(this)
        },
        pinned: 'left',
        lockPinned: true,
        width: 150
      });

  }
    }

    console.log("this.dynamicData");

    console.log(this.dynamicData);

    for (let i = 0; i < this.dynamicData.length; i++) {



      console.log("e");

      console.log(this.dynamicData[i]);

      if (this.dynamicData[i].showinGrid) {

        let fieldName = "";

        console.log(this.dynamicData[i].fieldType);

        console.log(this.dynamicData[i].fieldType == "valueDropDown");

        //if columntype is valueparentdropdown or valuedropdown then dropdownvalues are storing into columnname
        if (this.dynamicData[i].fieldType == "valueParentDropDown" || this.dynamicData[i].fieldType == "valueDropDown") {

          fieldName = this.dynamicData[i].dropDownValues;

          console.log(fieldName);

        }
       
                  else if (
            (this.dynamicData[i].fieldType == "Linked Fields" || 
            this.dynamicData[i].fieldType == "Select List - Static")
            &&
            !(this.tableName === "objectmetadata" 
              && this.dynamicData[i].fieldName === "pagelayoutnames")
          ) {

            fieldName = this.dynamicData[i].fieldName.toString() + 1;

          }


        else {

          fieldName = this.dynamicData[i].fieldName;

          console.log(fieldName);

        }

        console.log("fieldName");

        console.log(fieldName);
        console.log(this.dynamicData[i])
        /**
         * @author Ravi G
         * @Date 27-01-2023
         * @Desc filepath contain s3 path and below code for show the button in grid
         */
        if (this.dynamicData[i].filePath){
          this.columnDefs.push({
            headerName: this.dynamicData[i].agGridColumnName,
            headerTooltip: this.dynamicData[i].agGridColumnName,
            cellRenderer: "dynamicscreendownloadLink",
            cellRendererParams: {
              docdownload: this.dynamicScreenDownloadLink.bind(this),
            },
            field: fieldName,
            filter: "agTextColumnFilter",
            width: 100
          });


        }
        else if(this.dynamicData[i].agGridColumnName=="Download Log File"){
          console.log('Download Log File')
          this.columnDefs.push(
          {
            headerName: "Download Log File",
            filter: false,
            cellRenderer: "logfile",
            cellRendererParams: {
              downloadlogfile:this.logFile.bind(this),
            },
            lockPinned: true,
          });
        }
        else if(this.dynamicData[i].agGridColumnName=="Build Status"){
          this.columnDefs.push(
          {
            headerName: "Build Status",
            headerTooltip: 'Build Status',
      tooltipValueGetter: (params) => 'Build Status : ' + params.value,
      field: 'buildStatus',
      filter: 'agTextColumnFilter',
      width: 150,
      cellStyle: function (params) {
        if (params.value == 'Build Success') {
          return { color: 'green' };
        } else {
          return { color: 'red' };
        }
      }
          });
        }
        else{
          this.columnDefs.push({
            headerName: this.dynamicData[i].agGridColumnName,
            headerTooltip: this.dynamicData[i].agGridColumnName,
            tooltipValueGetter: params => this.dynamicData[i].agGridColumnName + " : " + params.value,
            field: fieldName,
            filter: "agTextColumnFilter",
            width: 180
          });

        }



      }

    }


    this.columnDefs.push({
      headerName: 'Status',
      headerTooltip: 'Status',
      tooltipValueGetter: (params) => 'Status : ' + params.value,
      field: 'status',
      filter: 'agTextColumnFilter',
      width: 150,
      cellStyle: function (params) {
        if (params.value == 'Yes') {
          return { color: 'green' };
        } else {
          return { color: 'red' };
        }
      }
    });

    // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    if (this.headerNameHtml === "Objects") {
      this.paginationPageSize = this.constants.vaultpagesize;
    }else{
      this.paginationPageSize = this.constants.pagesize;
    }
    this.rowSelection = this.constants.rowselection;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    this.retrieveS3path();

    var userName = localStorage.getItem("AuthUsername");

    console.log(userName);

    let userData: any = await this.service.retrieveSingleRecordService("users", "username", userName);

    let userid = userData[0].userid;
    console.log(userid)
    // this.dnsDropDown(userid);



  }
  retrieveS3path(){
    if(this.tableName=="keyphrasescatalogmstr"){
      this.spinner.start();
       this.service.retrieveS3Path().subscribe(res => {
        console.log(res.data);
                if (res!=null) {
console.log(res);
this.s3Path=res.data;
console.log(this.s3Path);
this.spinner.stop();
        } else {
          console.log(res);
this.s3Path=res;
console.log(this.s3Path);
          this.spinner.stop();
        }
    });
    }
  }
  downloadfilefromS3(s3Path){
    
    console.log(this.s3Path);
    if(this.s3Path===undefined || this.s3Path=== "" || this.s3Path ===null){
      this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

    }else{
      this.spinner.start();
      let fileName =  this.s3Path.split('/').pop()
      console.log(fileName);
      let data = {
        s3Path:this.s3Path,
      };
      console.log(data);
      console.log(data.s3Path
);


      this.service.downloadFileFromS3(data).subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        console.log(responseData);
        if (responseData){
          this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        } else{
          
          console.log(x)
          var newBlob = new Blob([x]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }




      })

      this.spinner.stop();
    }

  }
  refreshRun(){
    this.spinner.start();
    this. onGridReady(this.temprunHistory);
    this.spinner.stop();
  }
  
  logFile(logFilePath){
    // console.log(e.rowData)
    let s3FilePath = logFilePath.rowData.logFile
    console.log(logFilePath.rowData.logFile);
    console.log(logFilePath);

    if(s3FilePath===undefined || s3FilePath=== "" || s3FilePath ===null){
      this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

    }else{
      this.spinner.start();
      let fileName =  s3FilePath.split('/').pop()
      console.log(fileName);
      let data = {
        s3Path:s3FilePath,
      };
      this.service.downloadFileFromS3(data).subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData){
          this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        } else{
          console.log(x)
          var newBlob = new Blob([x]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }




      })

      this.spinner.stop();
    }

  }

  //excel export function
  onBtExport() {

    this.gridAPI.exportDataAsCsv();

  }

  //pagination code
  onPaginationChanged() {

    if (this.gridAPI && this.tableName!="exceptionsmstr"&&this.tableName!="loginauditmstr") {
      

      this.lastPage = this.gridAPI.paginationIsLastPageFound();

      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1

      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1

      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1

      this.totalPages = this.gridAPI.paginationGetTotalPages();
      

    }
   

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    if((this.tableName=='exceptionsmstr' ||this.tableName=='loginauditmstr')){
    
    if(searchValue!=null&&searchValue!=undefined&&searchValue>=1&&searchValue<=this.totalPages){
      this.currentPage= searchValue;
     
  this.retrievePaginated(this.currentPage,this.gridAPI.paginationGetPageSize(),0);
    
  }
  else if(searchValue!=null&&searchValue!=undefined&&searchValue>=1&&searchValue>this.totalPages){
    this.currentPage= this.totalPages;
     
  this.retrievePaginated(this.currentPage,this.gridAPI.paginationGetPageSize(),0);

  }
  else{
    this.currentPage=1;
    this.retrievePaginated(this.currentPage,this.gridAPI.paginationGetPageSize(),0);
  }
    }
    this.gridAPI.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    if((this.tableName=='exceptionsmstr'||this.tableName=='loginauditmstr')&&this.currentPage!=null&&this.currentPage!=undefined&&this.currentPage>=1){
     let currPageSize= this.gridAPI.paginationGetPageSize();
    
      this.retrievePaginated(this.currentPage,Number(value),0);
      this.totalPages=Math.ceil(this.fixedTotalPageRecord/Number(value))
    }
     
    this.gridAPI.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {
    
    

  if((this.tableName=='exceptionsmstr'||this.tableName=='loginauditmstr')&&this.currentPage+1<=this.totalPages){
    this.currentPage++;
   
this.retrievePaginated(this.currentPage,this.gridAPI.paginationGetPageSize(),0);
  
}
else{
  this.gridAPI.paginationGoToNextPage();
}
   

  }

  // below function for going to previous page
  async onBtPrevious() {
    if((this.tableName=='exceptionsmstr'||this.tableName=='loginauditmstr')&&this.currentPage-1>=1){
      this.currentPage--;
     
  this.retrievePaginated(this.currentPage,this.gridAPI.paginationGetPageSize(),0);
    
  }
   

    this.gridAPI.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {
    if(this.tableName=='exceptionsmstr'||this.tableName=='loginauditmstr'){
      this.currentPage=1;
     
  this.retrievePaginated(this.currentPage,this.gridAPI.paginationGetPageSize(),0);
    }

    this.gridAPI.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {
    if(this.tableName=='exceptionsmstr'||this.tableName=='loginauditmstr'){
      this.currentPage=this.totalPages;
     
  this.retrievePaginated(this.currentPage,this.gridAPI.paginationGetPageSize(),0);
    }

    this.gridAPI.paginationGoToLastPage();

  }
  //pagination code ends

  // below function is to load the ag grid
  async onGridReady(params) {
    this.temprunHistory = params
    console.log(this.dynamicData)

    for (let i = 0; i < this.dynamicData.length; i++) {

      if (this.dynamicData[i].fieldType == "valueDropDown" || this.dynamicData[i].fieldType == "valueParentDropDown" || this.dynamicData[i].fieldType == "Linked Fields") {

        console.log(this.dynamicData[i].fieldName);

        console.log(this.dynamicData[i]);

        /*this.dropDowns.push([this.dynamicData[i].fieldName, this.dynamicData[i].dropDownIndex, this.dynamicData[i].agGridDecode, this.dynamicData[i].dropDownIDs, this.dynamicData[i].dropDownValues]);

        console.log(this.dropDowns);*/
        let templistObjectDropDown = "";
        templistObjectDropDown = await this.trnxCommonTs.retrieveTrnxDropDown(this.dynamicData[i].dropDownTableName, /*this.dynamicData[i].dropDownIdNameFilter, this.dynamicData[i].dropDownIdValueFilter,*/ this.dynamicData[i].dropDownIDs, this.dynamicData[i].dropDownValues, this.dynamicData[i].lookupTableName);
        this.listObjectDropDown.push(templistObjectDropDown)
        console.log(this.listObjectDropDown);

      }
      if (this.dynamicData[i].fieldType == "Select List - Static") {

        console.log(this.dynamicData[i].fieldName);
        console.log(this.dynamicData[i]);
      
       
        console.log(this.dynamicData[i].dropDownIDs);
        this.droupDownBindedIdName=this.dynamicData[i].dropDownIDs;
        this.droupDownBindedName=this.dynamicData[i].dropDownValues;
        console.log(this.droupDownBindedIdName+"  "+this.droupDownBindedName);

        /*this.dropDowns.push([this.dynamicData[i].fieldName, this.dynamicData[i].dropDownIndex, this.dynamicData[i].agGridDecode, this.dynamicData[i].dropDownIDs, this.dynamicData[i].dropDownValues]);

        console.log(this.dropDowns);*/
        let templistObjectDropDown = "";
        console.log(this.dynamicData[i].dropDownTableName, /*this.dynamicData[i].dropDownIdNameFilter, this.dynamicData[i].dropDownIdValueFilter,*/ this.dynamicData[i].dropDownIDs, this.dynamicData[i].dropDownValues, this.dynamicData[i].lookupTableName);
        templistObjectDropDown = await this.trnxCommonTs.retrieveTrnxDropDown(this.dynamicData[i].dropDownTableName, /*this.dynamicData[i].dropDownIdNameFilter, this.dynamicData[i].dropDownIdValueFilter,*/ this.dynamicData[i].dropDownIDs, this.dynamicData[i].dropDownValues, this.dynamicData[i].lookupTableName);
        this.listObjectDropDown.push(templistObjectDropDown)
        console.log(this.listObjectDropDown);
        console.log(this.listObjectDropDown[0][0].lookupvalue);

      }

    }

    this.gridAPI = params.api;
  

    this.gridColumnAPI = params.columnApi;
    
    this.params =params
 console.log(this.tableName);
 
    //api call to get the location data
    if(this.tableName=='exceptionsmstr'||this.tableName=='loginauditmstr'){
     
      await this.retrievePaginated(this.currentPage,this.gridAPI.paginationGetPageSize(),1);
    }else{
    await this.retrieve();
    }
  }
  /*
  @Author: Venkata Shyam
  @Date:22-05-2025
  @Description: Check box for selecting all the rows of grid from source to target
   */
  selectedRows=[]
onHeaderCheckboxChange(checked: boolean) {
  const allRowsData = [];

  // Check if filter is active
  const isFilterActive = this.gridAPI.isAnyFilterPresent();

  if (checked) {
    // Select only filtered rows
    if (isFilterActive) {
      this.gridAPI.forEachNodeAfterFilter((node) => {
        node.data.isSelected = true;
        allRowsData.push(node.data);
      });
    } else {
      // Select all rows
      this.gridAPI.forEachNode((node) => {
        node.data.isSelected = true;
        allRowsData.push(node.data);
      });
    }
  } else {
    // Uncheck all rows
    this.gridAPI.forEachNode((node) => {
      node.data.isSelected = false;
    });
    this.selectedRows = [];
  }

  // Refresh only the Action column
  this.gridAPI.refreshCells({
    columns: ['isSelected'],
    force: true
  });

  console.log('Selected rows data after header checkbox clicked:', allRowsData);

  // You can store it in a class variable if needed
  this.selectedRows = allRowsData;
  console.log(this.selectedRows)
}

  /*
  @Author: Venkata Shyam
  @Date:22-05-2025
  @Description: Check box for selecting individual rows of grid from source to target particularly for selected
   */
checkboxIcon(event: any) {
  const row = event?.rowData;
  // if (!row) return; // Defensive: exit if no row data

  if (event.checked) {
    // Add row if not already present
    const exists = this.selectedRows.find(r => r.id === row.id);
    if (!exists) {
      this.selectedRows.push(row);
    }
  } else {
    // Remove row on uncheck
    this.selectedRows = this.selectedRows.filter(r => r.id !== row.id);
  }

  // Force change detection by creating a new array reference
  this.selectedRows = [...this.selectedRows];

  console.log('Updated selected rows:', this.selectedRows);
}

/*
  @Author: Venkata Shyam
  @Date:23-05-2025
  @Description: Method to copy the selected rows  of grid from source to target
   */
submitSelectedRows(){

  const confirmed = window.confirm('Are you sure you want to copy the selected objects to the target?');
  if (!confirmed) {
    return;
  }

  console.log('Submitting selected rows:', this.selectedRows);
  this.spinner.start();
  this.commonService.copyObjectsFromSourceToTarget(this.selectedRows,).subscribe((response) => {
    console.log(response);

    if (response.error == true) {
      this.spinner.stop();
      this.snackbar.open(response.statusMessage, 'OK', { duration: 5000 });
      return null;
    } else {
      this.spinner.stop();
      this.userRoleNameData = response;
      console.log(this.userRoleNameData)
    }
  });
}
  
  
  
  updateHeaderCheckboxState() {
    let allSelected = true;
    this.gridAPI.forEachNode((node: any) => {
      if (!node.data.isSelected) {
        allSelected = false;
      }
    });
    // Update your header checkbox manually here if needed (optional)
  }
  

  // Aggrid Edit function
  editIcon(e) {

    console.log(e);

    let rowData = e.rowData;

    console.log(rowData);
    if(this.headerNameHtml==="S3 Paths") {
      if(confirm(this.constants.edit_warning) == true){
        if (this.screenTypeTOrM == "Master") {

          this.master(rowData);

        }

        else {

          this.transaction(rowData);

        }
    }
  }
    else{
      if (this.screenTypeTOrM == "Master") {

        this.master(rowData);

      }

      else {

        this.transaction(rowData);

      }
    }
 

  }
  buildIcon(e) {

    console.log(e);

    let rowData = e.rowData;

    console.log(rowData);

    this.service.buildProject(rowData.keyphrasescatalogmstrid).subscribe(res => {
      console.log(res.data);
      this.logFilePath=res.data;
      this.res=res.statusMessage
console.log(this.logFilePath);
      if (res!=null) {
console.log(res);
this.spinner.stop();
      } else {
        console.log(res);
        this.spinner.stop();
      }
  });

  }
  checkoutFiles(e) {

    console.log(e);

    let rowData = e.rowData;

    console.log(rowData);
    let path=e.fieldValue;
    console.log(path)
    let fileName =  path.split('/').pop()
      console.log(fileName);
      this.spinner.start();
      let body={
        id:rowData.keyphrasescatalogmstrid,
        filePath:path
      }
    this.service.checkoutFiles(body).subscribe(res => {
      console.log(res)
        const isJsonBlob = (body) => body instanceof Blob && body.type === "application/json";
        const responseData = isJsonBlob(res)
        console.log(responseData);
        if (responseData){
          this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        } else{
          console.log(res)
          var newBlob = new Blob([res]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }




      })

      this.spinner.stop();
    }

  async binaryFormatImage(inputObject) {

    let response = await this.service.downloadImage(inputObject.keyValue)

    console.log(response);

    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var newBlob = new Blob([response]);

    console.log(newBlob);

    var reader: FileReader = new FileReader();

    reader.onloadend = e => {

      console.log(reader.result);

      inputObject.keyValue = reader.result.toString();

      inputObject.imageShow = true;

      inputObject.imageShow1 = true;

      inputObject.binaryFormat = true;

    };
    reader.readAsDataURL(newBlob);

  }


  // abhishek tomar
  // 29-03-2023
  // adding dropdown value and sending full object with delete api
  addingAdditionalParameters(ngModelTemporary,droupDownBindedName,droupDownBindedId,agGridColumnNameOfDynamicData){

  
    let arr=[];
    
    
    for(let i=0; i<this.listObjectDropDown.length; i++){
    for(let j=0; j<this.listObjectDropDown[i].length; j++){
     
      let obj={}
      
      obj['dropDownValue']=this.listObjectDropDown[i][j][droupDownBindedName];
      obj['dropDownId']=this.listObjectDropDown[i][j][droupDownBindedId];
     if(this.listObjectDropDown[i][j][droupDownBindedName]!=undefined){
      arr.push(obj);
     }
  
     
     console.log(droupDownBindedName);
      if(this.listObjectDropDown[i][j][droupDownBindedId]==ngModelTemporary.keyValue&&ngModelTemporary.agGridColumnName==agGridColumnNameOfDynamicData){
        
        this.checkingDuplicateInNgModel(ngModelTemporary.keyName,this.ngModelObject);
        
        ngModelTemporary['value']=this.listObjectDropDown[i][j][droupDownBindedName];
  
  
       
        
      }
      
    }
    
    }
    ngModelTemporary['dropDownIdValues']=arr;
    console.log(this.ngModelObject)
    this.checkingDuplicateInNgModel(ngModelTemporary.keyName,this.ngModelObject);
    this.ngModelObject.push(ngModelTemporary);
 
  }
  checkingDuplicateInNgModel(keyName,ngModelObject){
    let arr=[]
    console.log(this.ngModelObject);
     for(let i=0; i<this.ngModelObject.length; i++){
      
       if(this.ngModelObject[i].keyName==keyName){
            console.log(keyName);
         this.ngModelObject.splice(i,1);
         
         
       }
       else{
         arr.push(ngModelObject[i]);
       }
     }
     //console.log(this.ngModelObject);
     //this.ngModelObject=arr;
      console.log(arr);
     console.log(this.ngModelObject);
   }  

  childDropDown(ngModelTemporary) {
    let agGridColumnNameOfDynamicData;
   let droupDownBindedName
   let droupDownBindedId
   console.log(ngModelTemporary);
    
    for (let i = 0; i < this.dynamicData.length; i++) {

      if (this.dynamicData[i].fieldType == "valueDropDown" || this.dynamicData[i].fieldType == "valueParentDropDown" || this.dynamicData[i].fieldType == "Linked Fields") {
        if(this.dynamicData[i].agGridColumnName==ngModelTemporary.agGridColumnName){

       

        console.log(this.dynamicData[i].fieldName);

        console.log(this.dynamicData[i]);
       
      
       
        console.log(this.dynamicData[i].dropDownIDs);
        droupDownBindedId=this.dynamicData[i].dropDownIDs;
        droupDownBindedName=this.dynamicData[i].dropDownValues;
        agGridColumnNameOfDynamicData=this.dynamicData[i].agGridColumnName;
     

       this.addingAdditionalParameters(ngModelTemporary,droupDownBindedName,droupDownBindedId,agGridColumnNameOfDynamicData)
        }
        
      }
      if (this.dynamicData[i].fieldType == "Select List - Static") {
        if(this.dynamicData[i].agGridColumnName==ngModelTemporary.agGridColumnName){

       
      
       
        
        agGridColumnNameOfDynamicData=this.dynamicData[i].agGridColumnName;
        droupDownBindedId=this.dynamicData[i].dropDownIDs;
        droupDownBindedName=this.dynamicData[i].dropDownValues;
      


        this.addingAdditionalParameters(ngModelTemporary,droupDownBindedName,droupDownBindedId,agGridColumnNameOfDynamicData)

      }
    }

    }
  }
  // Aggrid Delete function
  async deleteIcon(e) {
    

    if (e.rowData.status == 'No' || e.rowData.status == null) {

      this.trnxCommonTs.checkingStatusSnackBar();

    }

    else {

      if (confirm(this.constants.confirmDeletion) == true) {

        console.log(this.screenTypeTOrM);
        console.log(e);
        
     
        for(let k in e.rowData){
          for(let i=0; i<this.ngModelObject.length; i++){
            if(k==this.ngModelObject[i].keyName){
              this.ngModelObject[i].keyValue=e.rowData[k];
              if(this.ngModelObject[i].fieldType=="Select List - Static"){
                this.childDropDown(this.ngModelObject[i]);
              }
            }
          }
          console.log(e.rowData[k]);
        }
        console.log(this.ngModelObject);    
        console.log(this.dynamicData);
        await this.trnxCommonTs.trnxDeleteIcon(e, this.tableName, this.ngModelObject, this.tableID, this.screenTypeTOrM);

        await this.retrieve();

      }

    }

  }

  async retrieve() {
    console.log(this.tableName);

   // console.log("dsafafgd")
    this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, /*this.dropDowns,*/ this.ngModelObject, this.recordsStart);
  
    console.log(this.retrieveObject);
    if(this.tableName === "objectmetadata"){
      this.dataFiltered = this.retrieveObject.filter(
        item => !(item.source && item.source.trim().toLowerCase() === "stage")
      );
      
      console.log(this.dataFiltered);
      console.log("Filtered Result:", this.dataFiltered);
      console.log("Filtered out", this.retrieveObject.length - this.dataFiltered.length, "items");
  
      // this.gridAPI.setGridOption('rowData', this.dataFiltered);
    } else {
      if (this.headerNameHtml === 'JSuite Properties') {
        this.categoriesList = Array.from(
          new Map(
            this.retrieveObject
              .filter(item => item.propertycategory1 !== null && item.propertycategory1 !== '')
              .map(item => [item.propertycategory1, item])
          ).values()
        );
        this.filteredData = this.retrieveObject.filter(
          item => item.propertycategory1 === this.categoriesList[0].propertycategory1
        );
        this.gridAPI.setGridOption('rowData', this.filteredData)
        console.log(this.filteredData)
        console.log(this.categoriesList)
      } else {
        this.gridAPI.setGridOption('rowData', this.retrieveObject);

      }
      
    }

    if(this.tableName === "objectmetadata"&&this.name!=undefined){
      console.log(this.name)
      if(this.name.includes("Source_")){
        console.log("It is source")
      } 
      this.selectDns(this.name)
      
      
    }

  }
  onCategoryRowClicked($event: any) {
    const category = $event.data.propertycategory1;
    console.log('Row clicked:', category);
    this.filteredData = this.retrieveObject.filter(
      item => item.propertycategory1 === category
    );
    this.gridAPI.setGridOption('rowData', this.filteredData)
  }
  onCategoryGridReady($event: any) {
    const rowData = $event.data;
    console.log('Row clicked:', rowData);
    }
  async retrievePaginated(pageNo,pageSize,totalRecords) {
    
  if(pageNo<=0||pageNo==undefined||pageNo==null){
    pageNo=1;
    this.currentPage=1;
  }

    this.retrieveObject = await this.trnxCommonTs.retrieveTrnxPaginated(this.tableName, this.listObjectDropDown, /*this.dropDowns,*/ this.ngModelObject, this.recordsStart,pageNo,pageSize,totalRecords);

   if(totalRecords==1){
    for (let i = 0; i < this.retrieveObject.length; i++) {
      console.log(this.retrieveObject[i])
      console.log("totalRecords" in this.retrieveObject[i]);
      if ("totalRecords" in this.retrieveObject[i]) {
       
        console.log(Number(this.retrieveObject[i].totalRecords));
        console.log(Number(this.retrieveObject[i].totalRecords)/this.gridAPI.paginationGetPageSize());
        
        this.fixedTotalPageRecord =Number(this.retrieveObject[i].totalRecords);
        
         console.log(this.fixedTotalPageRecord);
        this.totalPages=Math.ceil(this.fixedTotalPageRecord/this.gridAPI.paginationGetPageSize());
        this.retrieveObject.splice(i, 1);
        break;
      }
    }

  }
    console.log(this.retrieveObject);
    this.gridAPI.setGridOption('rowData', this.retrieveObject);
    

  }

  openForm(buttonName) {

    console.log(this.listObjectDropDown)
    this.buttonName = buttonName;

    let width = "80%";

    if (this.bootstrapColumn == 1) {

      width = "55%";

    }

    let dialogRef = this.dialog.open(TrnxBasePopupScreenComponent, {
      maxWidth: '100vw',
      height: "95%",
      width: width,
      data: { ngModelObjectDivision: this.ngModelObjectDivision, ngModelObject: this.ngModelObject, tableName: this.tableName, dynamicData: this.dynamicData, retrieveObject: this.retrieveObject, buttonName: this.buttonName, listObjectDropDown: this.listObjectDropDown, bootstrapColumn: this.bootstrapColumn, tableID: this.tableID, headerNameHtml: this.headerNameHtml, trnxScreenId: this.trnxScreenId, update: "parentTrue", screenTypeTOrM: this.screenTypeTOrM,selectedObjectDns:this.name },
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);

      this.listObjectDropDown = result;

      this.retrieve();

    });

  }

  openSaveForm(buttonName) {
    console.log(this.listObjectDropDown)
    this.buttonName = buttonName;

    let width = "80%";

    if (this.bootstrapColumn == 1) {

      width = "55%";

    }

    let dialogRef = this.dialog.open(TrnxBasePopupScreenComponent, {
      maxWidth: '100vw',
      height: "90%",
      width: width,
      data: { ngModelObjectDivision: this.ngModelObjectDivision, ngModelObject: this.ngModelObject, tableName: this.tableName, dynamicData: this.dynamicData, retrieveObject: this.retrieveObject, buttonName: this.buttonName, listObjectDropDown: this.listObjectDropDown, bootstrapColumn: this.bootstrapColumn, tableID: this.tableID, headerNameHtml: this.headerNameHtml, trnxScreenId: this.trnxScreenId, screenTypeTOrM: this.screenTypeTOrM,selectedObjectDns:this.name },
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);

      this.listObjectDropDown = result;

      this.retrieve();

    });
  }

  master(rowData) {

    console.log(this.screenTypeTOrM);

    console.log(rowData);


    if (rowData.status == 'No' || rowData.status == null) {

      this.trnxCommonTs.checkingStatusSnackBar();

    } else {

      this.buttonName = this.constants.btnnameupdate;

      this.ngModelObject = this.trnxCommonTs.trnxEditIcon(this.ngModelObject, rowData);
      console.log(this.ngModelObject)

      this.ngModelObject.forEach(inputObject => {


        if (inputObject.imageName != null && inputObject.keyValue != null) {

          if ((inputObject.keyValue).length > 0) {

            let extension: any;

            if ((inputObject.keyValue).includes(".")) {

              extension = (inputObject.keyValue).substring((inputObject.keyValue).lastIndexOf(".") + 1);

              console.log(extension);

            }

            if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {

              this.binaryFormatImage(inputObject);

            }

          }

        }

        if (inputObject.fieldType == "Password") {

          if ((inputObject.keyValue != undefined) && (inputObject.keyValue != null)) {

            if (inputObject.keyValue.toString() != "") {

              console.log(inputObject.fieldType);

              inputObject.keyValue ="";
               

            }

          }

        }

      });

      console.log(rowData);

      console.log(this.ngModelObject);

      this.openForm("Update");

    }

  }

  transaction(rowData) {

    console.log(this.screenTypeTOrM);

    console.log(rowData);

    console.log(this.tableName);

    //tMRD is TransactionMasterRowData.
    let tMRD = rowData;

    let tableNameindex = 0;
    tableNameindex = this.tableName.lastIndexOf("mstr");
    console.log(tableNameindex)
    let childTableName = this.tableName.slice(0, tableNameindex);
    childTableName = childTableName + "trxn";
    console.log(childTableName)

    let childKey = "";
    console.log(childTableName)
    console.log(this.tableName + "id")
    for (var key in rowData) {
      if (key.includes(this.tableName + "id")) {
        console.log(rowData[key])
        childKey = rowData[key]
      }
    }

    console.log(childTableName);

    console.log(this.tableName + "id");

    console.log(this.trnxScreenId);

    console.log(childKey);

    console.log(this.headerNameHtml);

    console.log(this.tableName + "id");

    //masterTableId is added, it is storing transaction master primary key name. TMTN is TransactionMasterTableName.
    let dialogRef = this.dialog.open(TrnxchildBaseScreenComponent, {
      maxWidth: '100vw',
      height: "90%",
      width: "95%",
      data: { tableName: childTableName, tableId: this.tableName + "id", trnxScreenId: this.trnxScreenId, childKey: childKey, headerNameHtml: this.headerNameHtml, masterTableId: this.tableName + "id", tMTN: this.tableName, tMRD: tMRD, listObjectDropDown: this.listObjectDropDown },
      disableClose: true
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {

      console.log(result);

      this.retrieve();

    });

  }

  scheduleIcon(e) {

    console.log(e);

    console.log(e.rowData.templatecreationmstrid);

    let dialogRef = this.dialog.open(ReportTemplatePopupComponent, {
      maxWidth: '100vw',
      height: "95%",
      width: "80%",
      data: { "reportName": e.rowData.reportname,"reportTemplateId":e.rowData.templatecreationmstrid,"screenName":'Trnx Base Screen' }
    });


  }
  refreshAttribute(e) {
    /* @added by Ravi G
        @date 18-11-2022
        @@desc refresh the vault object attributes
     */
    if (confirm('Are you sure you want to refresh attribute?')) {
      console.log(e.rowData.objectname);
      let objname = e.rowData.objectname;
     // let vaultDnsname = this.localStorageSettings.getSettings("vaultDnsname");
      this.spinner.start();
      const vaultDnsName=this.name.replace(/^Source_/, '').replace(/^Target_/, '');
      this.service.refereshObjectMetaData(vaultDnsName, objname).subscribe(res => {
        if (res.error === true) {
          this.spinner.stop();

          this.snackbar.open(res.statusMessage, "OK", {duration: 5000});

        } else {

          this.spinner.stop();

          this.snackbar.open(this.constants.objectRefreshed, "OK", {duration: 5000});
          this.onGridReady(this.params)


        }

      })
    }
  }
  /**
   * @author Ravi G
   * @Date 27-01-2023
   * @Desc download attachments for all dynamic screens
   */
  dynamicScreenDownloadLink(e){

    // var entry = e.rowData
    // var name;
    // for (name in entry){
    //   console.log(name);
    // }
    // console.log(e.rowData);
    // console.log(this.objects);
    // for (let i = 0; i < this.objects.length; i++) {
    //   if(this.dynamicData[i] === e.rowData) {
    //     console.log(this.dynamicData[i]);
    //   }
    //
    // }

    let  s3FilePath=''
    s3FilePath = e.fieldValue

    // e.rowData.filter(value =>{
    //   console.log(value);
    //   if (value.keyValue = e.fieldValue){
    //     console.log(value.key);
    //   }
    // })

    let entries = Object.entries(e.rowData);
    let fieldName =''
    for (const [key, value] of entries) {

      if ( value == e.fieldValue){
        fieldName = key

      }
    }

    if (s3FilePath !='' && s3FilePath != null && s3FilePath !=undefined) {
     // let fileName =  e.rowData[0]

      let fileName =  s3FilePath.substring(s3FilePath.indexOf(fieldName+"_") + fieldName.length + 1);

      let data = {
        's3Path':s3FilePath,
      };
      this.spinner.start();
      if(e.rowData.buildStatus=='Build Success' && s3FilePath.startsWith('src')){
        this.checkoutFiles(e)
     }
     else{
      this.service.downloadFileFromS3(data).subscribe(x => {
        this.spinner.stop()
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should

        console.log(x)
        const isJsonBlob = (data) => data instanceof Blob && data.type === "application/json";
        const responseData = isJsonBlob(x)
        if (responseData){
          this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

        }
        else{
          console.log(x)
          var newBlob = new Blob([x]);
          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)

          var link = document.createElement('a');
          link.href = data;
          link.download = fileName;
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);

        }




      })
    }
    }else{

      this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

    }

    this.spinner.stop();
  }
  
  openRefreshHistory(buttonName) {
    console.log(this.listObjectDropDown)
    this.buttonName = buttonName;
    let width = "90%";
    let dnsId=this.localStorageSettings.getSettings("dnsName")
    console.log(this.dnsnames)
    for(let i=0;i<this.dnsnames.length;i++){
      if(this.dnsnames[i].name === this.name.replace(/^Source_/, '')){
        dnsId=this.dnsnames[i].id
        console.log("It is source", dnsId)
      }
      if(this.dnsnames[i].name === this.name.replace(/^Target_/, '')){
        dnsId=this.dnsnames[i].id
        console.log("It is target", dnsId)
      }
    }
    console.log("dnsId ====> "+dnsId)
    let dialogRef = this.dialog.open(ObjectMetadataRefreshHistoryPopupComponent, {
      maxWidth: '100vw',
      height: "80%",
      width: width,
      disableClose: true,
      data: {tableName: this.tableName, buttonName: this.buttonName, headerNameHtml: this.buttonName,dnsId:dnsId }
     
    });
  }

  openImportExportCentralized() {
    console.log(this.listObjectDropDown)
    let width = "60%";
    let dnsId = this.localStorageSettings.getSettings("dnsName")
    console.log(this.dnsnames)
    for (let i = 0; i < this.dnsnames.length; i++) {
      if (this.dnsnames[i].name === this.name.replace(/^Source_/, '')) {
        dnsId = this.dnsnames[i].id
        console.log("It is source", dnsId)
      }
      if (this.dnsnames[i].name === this.name.replace(/^Target_/, '')) {
        dnsId = this.dnsnames[i].id
        console.log("It is target", dnsId)
      }
    }
    console.log("dnsId ====> " + dnsId)
    let dialogRef = this.dialog.open(ImportExportCentralizedComponent, {
      maxWidth: '100vw',
      height: "80%",
      width: width,
      disableClose: true,
      data: { tableName: this.tableName, buttonName: this.buttonName, headerNameHtml: this.buttonName, dnsId: dnsId }

    });
  }
 /* @added by Nitin kumar
        @date 09-06-2023
        @@desc refresh the vault object attributes
     */
       async refreshAllObjectsAttribute() {
        let status = "";
        const response = await new Promise(resolve => {
          this.service.getRefreshStatus(this.localStorageSettings.getSettings("dnsName")).subscribe(resolve);
        });

    if(response !==null){
      const jsonString = JSON.stringify(response)
      const responseObject = JSON.parse(jsonString)
      status =responseObject.status;  
      console.log(status)
    }
        
        if(status==="Completed" || status ==="Failed" || response===null){

          if (confirm('Are you sure you want to refresh All Objects Attributes?')) {
            let vaultDnsname = this.localStorageSettings.getSettings("vaultDnsname");
            this.snackbar.open("Refresh Initiated", "OK", {duration: 5000});
            this.service.refereshObjectMetaData(vaultDnsname, "all").subscribe(res => {
              if (res.error === true) {
                this.spinner.stop();
      
                this.snackbar.open(res.statusMessage, "OK", {duration: 5000});
      
              } else {
      
                this.spinner.stop();
      
                this.snackbar.open(this.constants.objectRefreshed, "OK", {duration: 5000});
                
              }
      
            })
          }
         
         }else{
          this.snackbar.open("Please wait untill last Resfresh Complete.", "OK", {duration: 5000});
        
         }
        }

        /**
         * @Author Nitin Kumar
         * @param buttonName
         * method to retrieve vault object changes and open in new dialog
         * @Date 16/06/2024
         */

        openDetectedChanges(buttonName) {
  
          this.buttonName = buttonName;
          let width = "90%";
        
            let dialogRef = this.dialog.open(DetectChangesPopupVaultObjectComponent, {
              maxWidth: '100vw',
              height: "85%",
              width: width,
              data: {tableName: this.tableName, buttonName: this.buttonName, headerNameHtml: this.buttonName }
             
            });
          
        }

       
/**
 * @Author Nitin Kumar
 * @Date - 16/06/2024
 * @Desc this method to start the vault object changs detection
 * @param dnsName 
 */
     async startVaultObjectChnagesDetection(){

      //     let status = "";
      //     const response = await new Promise(resolve => {
      //       this.service.getVaultObjectChangesDetectionStatus(this.localStorageSettings.getSettings("dnsName")).subscribe(resolve);
      //     });
  
      // if(response !==null){
      //   const jsonString = JSON.stringify(response)
      //   const responseObject = JSON.parse(jsonString)
      //   status =responseObject.status;  
      //   console.log(status)
      // }
          
      //     if(status==="Completed" || status ==="Failed" || response===null){
  
      //       if (confirm('Are you sure you want to Detect Objects changes?')) {
        let status = "";
        const response = await new Promise(resolve => {
          this.service.getRefreshStatus(this.localStorageSettings.getSettings("dnsName")).subscribe(resolve);
        });

    if(response !==null){
      const jsonString = JSON.stringify(response)
      const responseObject = JSON.parse(jsonString)
      status =responseObject.status;  
      console.log(status)
    }
        
        if(status==="Completed" || status ==="Failed" || response===null){

          if (confirm('Are you sure you want to refresh All Objects Attributes?')) {
              //let vaultDnsname = this.localStorageSettings.getSettings("vaultDnsname");
            //  this.snackbar.open("Objects Changes Detection Initiated", "OK", {duration: 5000});

           // this.snackbar.open("Refresh Initiated", "OK", {duration: 5000});
            // waiting for response
           const vaultDnsName = this.name.replace(/^Source_/, '').replace(/^Target_/, '');
           this.service.detectChangesObjectMetadata(vaultDnsName).subscribe(res => {


                if (res.error === true) {
                  this.spinner.stop();
        
                  this.snackbar.open(res.statusMessage, "OK", {duration: 5000});
        
                } else {
        
                  this.spinner.stop();
                  this.snackbar.open(res.statusMessage, "OK", {duration: 5000});
        
               //   this.snackbar.open("Objects Change Detection Completed Successfully", "OK", {duration: 5000});
                  
            //   this.snackbar.open(this.constants.objectRefreshed, "OK", {duration: 5000});
                }
        
              })
            }
           
           }else{
           // this.snackbar.open("Please wait untill last Vault Object Changes Detection Complete.", "OK", {duration: 5000});
            this.snackbar.open("Please wait untill last Resfresh Complete.", "OK", {duration: 5000});
           }
          
        }
        /**
          @ModifiedBy: Shyam
          @Date : 08-02-2025
          @Note added dropsown of dns to show particular objects based on selected dns
         */
        dnsid:number
       async selectDns(tempdnschange) {        
        // this.retrieve();
        // this. onGridReady(this.temprunHistory);
          if (this.tableName !== "objectmetadata") {
            for(let i=0;i<this.vaultids.length;i++){
              if(this.vaultids[i].name === tempdnschange){
                tempdnschange=this.vaultids[i].target
              }
            }
          }
          console.log(this.vaultids)
          let dnschange = {
            "dnschange": tempdnschange,
            "username": this.localStorageSettings.getSettings("AuthUsername")
          };
          console.log(dnschange);
          this.spinner.start();
          console.log("Selected DNS:", dnschange);
          let matchedSourceId = null;

          for (let i = 0; i < this.vaultids.length; i++) {
            if (this.vaultids[i].source === tempdnschange) {
              matchedSourceId = this.vaultids[i].sourceDnsId;
              break; // exit loop once found
            }
          }
          if(tempdnschange.startsWith("Source_") || tempdnschange.includes("Source_")){
            console.log("It is source")
            this.columnsOfAction = true
          }else{
            console.log("It is target")
            this.columnsOfAction = false
          }
          
          console.log("Matched sourceDnsId:", matchedSourceId);
          const cleanedDnsName = tempdnschange.replace(/^Source_/, '').replace(/^Target_/, '');
          console.log("Cleaned DNS Name:", cleanedDnsName);
          
          
        
          // First API call - Get Tenant ID based on DNS Name
          try {
            console.log("Calling API for getTenantidBasedOnName...");
            const dnsvalue = await this.service.getTenantidBasedOnName(cleanedDnsName).toPromise();
            // this.dnsid = Number(dnsvalue)
            this.dnsid = matchedSourceId
            console.log("DNS ID:", this.dnsid);
           
            let tableData = await this.service.getTableDataByDns(this.tableName,this.dnsid).toPromise();
          
          
          
            // If current table is objectmetadata,
          // fetch all page layouts and map layout names
          // based on matching objectname inside layoutAttributes JSON.
          
            if (this.tableName === "objectmetadata") {

        const layouts: any = await this.service
          .getObjectPageLayouts()
          .toPromise();

        tableData.forEach(row => {

          const matchedLayouts = layouts
            .filter(l => {
              try {
                const attrs = JSON.parse(l.layoutAttributes);
                return attrs[0]?.objectname === row.objectname;
              } catch (e) {
                return false;
              }
            })
            .map(l => l.layoutLabelName)
            .join(', ');

          row.pagelayoutnames = matchedLayouts || "";
        });

      }

            console.log("Filtered Data:", tableData);
            // this.dynamicData = tableData;
            const modifiedData = tableData.map(row => ({
              ...row,
              isSelected: false
            }));
                
             this.dataFiltered = modifiedData.filter(item => {
             return !(item.source && item.source.trim().toLowerCase() === "stage");
            });
            console.log(this.dataFiltered)
            this.gridAPI.setGridOption('rowData', this.dataFiltered );
            // this.gridAPI.setGridOption('rowData', modifiedData);
          } catch (error) {
            console.error("Error occurred:", error);
            this.spinner.stop();
            alert('An error occurred while fetching the data.');
          } finally {
            this.spinner.stop(); // Ensure spinner stops in both success and error cases
          }
        
          //  this.screenService.retrieveselectedDNSofuser(dnschange).subscribe(async res => {
          //    if (res.error === true) {
       
          //      console.log(res);
       
          //      this.spinner.stop();
       
          //      this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          //      localStorage.clear();
          //      // finally navigate to login page
          //      this.spinner.start();
          //      this.router.navigate(['']);
          //      this.spinner.stop();
          //    }
          //    else {
       
          //      console.log(res)
          //      this.users = res.users;
          //              this.localStorageSettings.saveSettings("defaultVaultId", res.defaultVaultId);
          //              this.localStorageSettings.saveSettings("vaultIds", res.vaultIds);
          //              this.localStorageSettings.saveSettings("dnsName", res.dnsName);
          //              this.localStorageSettings.saveSettings("vaultDnsname", res.vaultDnsname);
          //              this.localStorageSettings.saveSettings("AuthToken", res.token);
          //      //if successfull it will navigate to user module
          //     // this.router.navigateByUrl("user");
        
          //    /**
          //     * @modified Vijay Badha
          //     * checking if the user has access to the selected dns if user doesnt have access
          //     * reverting back to the default dns
          //     */
              
          //     this.asignUserRoleService.reteriveuserRoleByTenantIdAndUserId(this.users.userid).subscribe(response => {
          //      if (response == null) {
          //        this.spinner.stop();
          //        this.snackbar.open("The user lacks authorization to view any screen.So changing DNS to "+this.defaultLoginDns.name, 'OK', {duration: 5000});
          //        alert("The user lacks authorization to view any screen for selected DNS .So changing DNS to "+this.defaultLoginDns.name)
                 
          //        this.selectDns(this.defaultLoginDns.url)
               
          //      }else if (response.error === true) {
       
          //        console.log(response);
       
          //        this.spinner.stop();
       
          //        this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});
       
          //      } else {
          //         this.spinner.stop();
          //        this.snackbar.open(res.message, "OK", { duration: 5000 });
          //       //  window.location.reload()
          //       this.cdRef.detectChanges();
          //      }
          //    })
       
               
       
          //    }
          //  })
         
         }
         
         
          dnsDropDown(){
          //  console.log(userid);
             console.log(localStorage.getItem("vaultIds"))
             console.log(localStorage.getItem("defaultVaultId"))
             this.defaultId=+localStorage.getItem("defaultVaultId");
            //  this.vaultids =JSON.parse(localStorage.getItem("vaultIds"));
             console.log(this.vaultids)
             /*
              Modified By-Abhishek T
              Date-06-12-2023
              Desc-doing empty the dnsnames array to avoid the dns records duplication
             */
              this.dnsnames=[];
             for(let i=0;i<this.vaultids.length;i++){
               if(true){
                 this.name = this.vaultids[i].target
                 this.defaultLoginDns=this.vaultids[i]
                 console.log(this.name)
                 this.localStorageSettings.saveSettings("SelectedDnsName",this.vaultids[i].name);
                 if (this.tableName === "objectmetadata"
                 ) {
                  
                  const sourceObj = {
                    id: this.vaultids[i].sourceDnsId,
                    name: this.vaultids[i].source,
                    url: this.vaultids[i].url
                  };
                
              //     const targetObj = {
              //       id: this.vaultids[i].targetDnsId,
              //       name: this.vaultids[i].target,
              //       url: this.vaultids[i].url
              //     };
              //     console.log(targetObj)
              //     console.log(sourceObj)
              //  this.dnsnames.push(targetObj);
                  this.dnsnames.push(sourceObj);
                  
                }
                else{
                 this.dnsnames.push(this.vaultids[i])
                }
               }
            
               console.log(this.dnsnames)
             }
         }
        
         loadGridData() {
          this.columnDefs = [];
          
          if (this.dynamicData.length) {
            this.dynamicData.forEach((col) => {
              this.columnDefs.push({
                headerName: col.agGridColumnName,
                field: col.fieldName,
                filter: "agTextColumnFilter",
                width: 150
              });
            });
          }
        }

        navigateToTarget() {
          const baseUrl = window.location.origin; // Gets "http://localhost:4200" or deployed domain
          const targetUrl = `${baseUrl}/user/Menubar/stageobject`;
          window.open(targetUrl, '_blank');
      }
      
 getRouterLink(event): any[] {
  if (event.label === 'Objects') {
    return ['/user/Menubar/trnxBaseComponent'];
  } else {
    return [`/user/Menubar/${event.link}`];
  }
}

getQueryParams(label: string): any {
  if (label === 'Objects') {
    return {
      screenType: 'Dynamic/Transactions',
      tableName: 'objectmetadata',
      headerNameHtml: 'Objects'
    };
  }
  return null;
}
     


      /**
	 * @Author: Venkata Shyam
	 * @Date:20-05-2025
	 * @apiNote : This method will support upload csv file functionality where it will insert/update the data into table based on tableName
	 */      
      onFileChange(event:any):void{
        const input = event.target as HTMLInputElement
        if(!input.files ||input.files.length===0){
          console.log("No file selected")
          this.snackbar.open("No file selected","OK",{ duration:5000 });
        }
        const file = input.files[0]
        const fileName =file.name
        const isCsvfile = fileName.endsWith('.csv')
        if (!isCsvfile) {
          alert('Only CSV files are allowed.');
          input.value = ''
          return;
        }
        const formData = new FormData();
        formData.append('file', file);
        console.log("CSV file ready to be sent:", fileName);
        console.log(this.tableName)
          const tablenameForUpload = this.tableName
          this.spinner.start();
          const dns = this.localStorageSettings.getSettings("dnsName");
          this.snackbar.open("Uploading file. Please wait...", "OK", { duration: 3000 });
        this.vaultObjectRelationshipService.uploadFileForVaultObjectRelationship(tablenameForUpload,dns,formData).subscribe(res=>{
          if(res.error){
            this.spinner.stop();
            this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
            input.value = ''
          }else{
            console.log(res);
            this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
            this.spinner.stop();
            input.value = ''
          }
         })
      }

        /**
	 * @Author: Venkata Shyam
	 * @Date:05-06-2025
	 * @apiNote : This method will support upload csv file functionality where it will insert the data into table based on tableName and if any duplicates
   *  are there then they are not modifying and getting back into the UI to display the same
	 */ 
      // excelFileUpload(event:any):void{
      //   console.log(event)
      //   const input = event.target as HTMLInputElement
      //   if(!input.files && input.files.length == 0){
      //     this.snackbar.open("No csv file is selected","OK",{duration: 5000});
      //   }
      //   const file = input.files[0]
      //   const fileName = file.name
      //   const isCsv = fileName.endsWith(".csv")
      //   if(!isCsv){
      //     alert('Only CSV files are allowed.');
      //     input.value = ''
      //     return;
      //   }
      //   const reader = new FileReader();
      //   reader.onload = ()=>{
      //     const csvText = reader.result as string
      //     const lines = csvText.split(/\r\n|\n/).filter(line => line.trim() !== '');

      //   if (lines.length === 0) {
      //     alert('Empty CSV file!');
      //      input.value = ''
      //     return;
      //   }

      //   const headers = lines[0].split(',')
      //    // Parse each subsequent line to object
      //    const parsedCsv = lines.slice(1).map(line => {
      //     const values = this.parseCsvLine(line);
      //     const obj: any = {};
      //     headers.forEach((header, i) => {
      //       const key = header.trim().replace(/^"+|"+$/g, ''); // remove quotes from header
      //       let rawValue = (values[i] || '').trim();
    
      //       // Clean the value: remove outer quotes and replace double double-quotes with single quotes
      //       if (rawValue.startsWith('"') && rawValue.endsWith('"')) {
      //         rawValue = rawValue.slice(1, -1).replace(/""/g, '"'); // Unescape
      //       }
    
      //       try {
      //         if ((rawValue.startsWith('{') || rawValue.startsWith('[')) &&
      //             (rawValue.endsWith('}') || rawValue.endsWith(']'))) {
      //           obj[key] = JSON.parse(rawValue);
      //         } else {
      //           obj[key] = rawValue;
      //         }
      //       } catch (e) {
      //         obj[key] = rawValue;
      //       }
            
      //     });
      //     return obj;
      //   });
      //    this.uploadData = {
      //     csvContent: parsedCsv,
      //     fileName: file.name,
      //     duplicates: false
      //   };
      //   console.log(this.uploadData)
      //   let dialogRef = this.dialog.open(UploadExcelFileComponent, {
      //           panelClass: 'custom-dialog-container-materialFulfilment',
      //           width: '85%',
      //           // height:'80%',
      //           autoFocus: false,
      //           data: { edata: this.uploadData},
      //           disableClose: true,
      //         });
      //         dialogRef.afterClosed().subscribe(result => {
      //         console.log(result)
      //          if(result){
      //           this.excelData = result
      //          this.sendExcelData()
      //          }
      //          input.value = '';
      //       })
        
      //   }
      //   reader.readAsText(file);
      // }

      //  parseCsvLine(line: string): string[] {
      //   const result: string[] = [];
      //   let current = '';
      //   let inQuotes = false;
      
      //   for (let i = 0; i < line.length; i++) {
      //     const char = line[i];
      //     const nextChar = line[i + 1];
      
      //     if (char === '"') {
      //       if (inQuotes && nextChar === '"') {
      //         current += '"'; // Escaped quote
      //         i++; // Skip next quote
      //       } else {
      //         inQuotes = !inQuotes;
      //       }
      //     } else if (char === ',' && !inQuotes) {
      //       result.push(current);
      //       current = '';
      //     } else {
      //       current += char;
      //     }
      //   }
      
      //   result.push(current);
      //   return result.map(cell => cell.trim());
      // }
      
      // sendExcelData(){
      //   const dnsname =this.name.replace(/^Source_/, '').replace(/^Target_/, '');
      //   this.vaultObjectRelationshipService.uploadFileForObjectmetadata(this.tableName,dnsname,this.excelData).subscribe(res=>{
      //     if(res.error){
      //       this.spinner.stop();
      //       this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      //       // input.value = ''
      //     }else{
      //       console.log(res);
      //       if (res?.message?.statusMessage) {
      //         this.snackbar.open(res.message.statusMessage, "OK", { duration: 5000 });
      //       }
      //       // this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
      //       this.spinner.stop();
      //       if (Array.isArray(res.duplicates) && res.duplicates.length > 0) {
      //         this.dialog.open(UploadExcelFileComponent, {
      //           width: '80%',
      //           data: { edata: { csvContent: res.duplicates },duplicates: true ,message: res.message}
      //         });
              
      //       }
      //       // input.value = ''
      //     }
      //    })
      // }
     
      
      
excelFileUploadForObjects(){
  const tablename= this.tableName
  let selectedNameOfdns
  if(tablename === 'loadobjectsmstr' || tablename === 'sqlscripts__j'){
    selectedNameOfdns = this.localStorageSettings.getSettings("dnsName")
  }else{
   selectedNameOfdns = this.name.replace(/^Source_/, '').replace(/^Target_/, '');
  }
  console.log(selectedNameOfdns)
  let dialogRef = this.dialog.open(UploadExcelFileComponent, {
              panelClass: 'custom-dialog-container-materialFulfilment',
              width: '95%',
              height:'80%',
              maxWidth:'100vw',
              autoFocus: false,
              data: { edata:tablename,dnsname:selectedNameOfdns},
              disableClose: true,
            });
            dialogRef.afterClosed().subscribe(result => {
            console.log(result)
             if(result){
              this.excelData = result
             if(tablename !== 'loadobjectsmstr' && tablename !== 'sqlscripts__j'){
                   this.selectDns(this.name)
              }else{
                this.refreshRun()
              }
            //  this.sendExcelData()
             }
             if(tablename !== 'loadobjectsmstr' && tablename !== 'sqlscripts__j'){
                   this.selectDns(this.name)
              }else{
                this.refreshRun()
              }
            //  input.value = '';
          })
      
  }
  


  importData() {
    if (this.headerNameHtml == "Objects") {
      this.importExportTableName = "objectmetadata";

     }
    
     if(this.tableName=="vaultconfigmstr"){
       console.log("<--- Inside upload Group Template --->")
            let width = "85%";
        let dialogRef = this.dialog.open(ImportZipComponent, {
              maxWidth: "70vw",
              height: "50%",
              width: width,
            data: { "tablename": "addminastraion"},
              disableClose: true,
            });
          
            dialogRef.afterClosed().subscribe((result) => {
              console.log(result);
          
              //this.reportCreationData = result;
          
              //this.vaultObjectService.retrieveobjectgroup();
            });
          

     } else{
        console.log("<--- Inside upload Group Template --->")
        let width = "85%";
      let dialogRef = this.dialog.open(ImportJsonComponent, {
          maxWidth: "70vw",
          height: "50%",
          width: width,
        data: {
            tablename: this.tableName,
            tenantid: this.dnsid,
            headerNameHtml: this.headerNameHtml   
          },

          disableClose: true,
        });
      
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
      
          //this.reportCreationData = result;
      
          //this.vaultObjectService.retrieveobjectgroup();
        });
      
      
    }
    
  }
    async exportData() {
      
      this.snackbar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
      let tenantid = localStorage.getItem("dnsName")

      if (this.headerNameHtml == "Objects") {
        this.importExportTableName = "objectmetadata";
        tenantid = this.dnsid+"";

      }

      if(this.tableName=="vaultconfigmstr"){

       
        const importType = "administration"
         try {
          
          console.log(this.dnsid);
          console.log(tenantid);
      const blob = await this.commonService.downloadzipFile("0", tenantid+"",importType);
      
      const link = document.createElement('a');
      const timestamp = new Date().getTime();
      link.href = window.URL.createObjectURL(blob);
      link.download = `${"test"}_export_${timestamp}.zip`;
      link.click();
      window.URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error('Error downloading JSON:', error);
    }
      }else{
     
  
      
      // if (this.headerNameHtml == "Company") {
      //   this.importExportTableName = "company";
      //   tenantid = this.dnsid+"";

      // }
        try {
          const blob = await this.commonService.downloadJsonFile(this.tableName, tenantid);
          const link = document.createElement('a');
          const timestamp = new Date().getTime();
          link.href = window.URL.createObjectURL(blob);
          link.download = `${this.tableName}_export_${timestamp}.json`;
          link.click();
          window.URL.revokeObjectURL(link.href);
  
        } catch (error) {
          console.error('Error downloading JSON:', error);
        }
      
      }
    }
    /*
    @Author: Shyam
    @Date: 24/11/2025
    @description: Added for button permission which are not loading at screen initialization time
    */

     hasPermissionToAccessButton(id: number) {
      return this.buttonIdList.includes(id);
   }
   /**
    * @Author-Asha Waghadure
    * @Date-13-12-2025
    * @Note-Added to execute mdl script from Manage Workspace screen
    */
   executeMdlScript(e) {
    if (e.rowData.mdlscriptstatus != null) {
    const confirmed = confirm(this.constants.confirmExecute);
    if (!confirmed) {
      return;
    }
    }
    
    this.spinner.start();

    console.log(e);

    let rowData = e.rowData;

    console.log(rowData);
    console.log(rowData.mdlscripts)
       
           let existingDataList=JSON.parse(rowData.mdlscripts);
           if(existingDataList.length==0){
                        this.spinner.stop();

            this.snackbar.open("Please select MDL script to execute.", "OK", { duration: 5000 });
            return; 
           }
      
           let scriptList;

   this.service
  .getjsuitePropertyByCategory(existingDataList[0].propertycategory)
  .subscribe((res: any) => {

    // extract list from commonServiceInfo
    const propertyData = res || [];

    const executionListString = existingDataList
      .filter(item => item.isexecutable)
      .sort((a, b) => +a.executionorder - +b.executionorder)
      .map(item => {
        let script = item.createmdltemplate;

        // Check for generic placeholder
        if (script.includes('{propertyvalue}')) {

          // Match using propertyname from SAME JSON
          const matchedProperty = propertyData.find(
            p => p.propertyname === item.propertyname
          );

          if (matchedProperty?.propertyvalue) {
            script = script.replace(
              '{propertyvalue}',
              matchedProperty.propertyvalue
            );
          }
        }

        return script;
      })
      .join('\n');

    console.log('Final Script:', executionListString);
    scriptList=executionListString;
    
    this.service.executeMdlScript(rowData.vaultconfigmstridtarget1
   ,executionListString,rowData.id).subscribe(res => {
      console.log(res.statusMessage);
      this.res=res.statusMessage
      if (res!=null) {
      console.log(res);
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", {duration: 5000});


      } else {
        console.log(res);
                this.spinner.stop();
                  this.snackbar.open(res.statusMessage, "OK", {duration: 5000});
      }
          this.retrieve();

  });
  });


  }


pageLayoutDetails(params: any) {
  
this.spinner.start();
  const objectName = params.rowData.objectname;

  this.commonService.getObjectPageLayouts().subscribe((response: any[]) => {

    if (!response || response.length === 0) {
      this.snackbar.open("No Page Layout Found", "OK", { duration: 4000 });
      return;
    }

    let popupData = [];

    response.forEach(layout => {

      if (layout.layoutAttributes) {

        try {
          const parsed = JSON.parse(layout.layoutAttributes);

          const filtered = parsed.filter(
            (item: any) => item.objectname === objectName
          );

          const mapped = filtered.map((item: any) => ({
            layoutlabel: item.page_layout_label,
            layoutname: item.page_layout_name,
            section: item.section_name,
            field: item.fieldlabel
          }));

          popupData = [...popupData, ...mapped];

        } catch (e) {
          console.error("JSON Parse Error:", e);
        }

      }

    });

    this.spinner.stop();
    if (popupData.length > 0) {
      this.openPageLayoutPopup(popupData);
    } else {
      this.snackbar.open("No Page Layout Details Found", "OK", { duration: 4000 });
    }

  });

}


openPageLayoutPopup(data: any[]) {

  const columndata = [{
    layoutlabel: "Layout Label",
    layoutname: "Layout Name",
    section: "Section",
    field: "Field"
  }];

  this.dialog.open(CommonPopupSearchComponent, {
    width: "70%",
    autoFocus: false,
    disableClose: true,
    data: {
      edata: data,
      page: "single",
      columns: columndata,
      selectedValue: [],
      hideCheckBox: true,
       title: "Page Layout Details"
     
    }
  });

}


}
